import _classCallCheck from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/createClass";
import _assertThisInitialized from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/assertThisInitialized";
import _inherits from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

import { Component } from 'react';
import PropTypes from 'prop-types';
import shallowEqual from 'shallowequal';
import keyboardOnlyOutlines from '@moxy/keyboard-only-outlines';

var KeyboardOnlyOutlines = /*#__PURE__*/function (_Component) {
  _inherits(KeyboardOnlyOutlines, _Component);

  var _super = _createSuper(KeyboardOnlyOutlines);

  function KeyboardOnlyOutlines() {
    var _this;

    _classCallCheck(this, KeyboardOnlyOutlines);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    _defineProperty(_assertThisInitialized(_this), "keyboardOutlinesOptions", void 0);

    return _this;
  }

  _createClass(KeyboardOnlyOutlines, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.applyKeyboardOutlines();
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate() {
      this.applyKeyboardOutlines();
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this.disposeKeyboardOutlines();
    }
  }, {
    key: "render",
    value: function render() {
      return this.props.children;
    }
  }, {
    key: "applyKeyboardOutlines",
    value: function applyKeyboardOutlines() {
      var options = {};

      if (this.props.stylesheetTarget != null) {
        options.stylesheetTarget = this.props.stylesheetTarget;
      }

      if (this.props.styles != null) {
        options.styles = this.props.styles;
      } // Skip if nothing changed


      if (shallowEqual(options, this.keyboardOutlinesOptions)) {
        return;
      }

      this.keyboardOutlinesOptions = options;
      this.disposeKeyboardOutlines();
      this.dispose = keyboardOnlyOutlines(options);
    }
  }, {
    key: "disposeKeyboardOutlines",
    value: function disposeKeyboardOutlines() {
      if (this.dispose) {
        this.dispose();
        this.dispose = undefined;
      }
    }
  }]);

  return KeyboardOnlyOutlines;
}(Component);

export { KeyboardOnlyOutlines as default };

_defineProperty(KeyboardOnlyOutlines, "propTypes", {
  children: PropTypes.node,
  stylesheetTarget: PropTypes.object,
  styles: PropTypes.string
});

_defineProperty(KeyboardOnlyOutlines, "defaultProps", {
  children: null
});